import * as React from 'react';
import Dashboard from './dashboard';


type DashboardHomeProps = React.ComponentProps<typeof Dashboard>;

export default function DashboardHome(props: DashboardHomeProps) {
  return <Dashboard {...props} />;
}
